import { render, staticRenderFns } from "./add-shiti.vue?vue&type=template&id=33368cfe&scoped=true&"
import script from "./add-shiti.vue?vue&type=script&lang=ts&"
export * from "./add-shiti.vue?vue&type=script&lang=ts&"
import style0 from "./add-shiti.vue?vue&type=style&index=0&id=33368cfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33368cfe",
  null
  
)

export default component.exports